module.exports = __webpack_public_path__ + "static/one_color_logo-3d9ebcdad53fdb815dd85f6556627257.png";